import React from 'react';

import { Grid, GridItem, Heading, Skeleton } from '@ecoinvent/ui';

import AppCard from 'components/UI/AppCard';
import useRelatedDatasets from 'hooks/data/datasets/useRelatedDatasets';
import { useIsShowingV4 } from 'hooks/useV4';
import useVersionInfo from 'hooks/useVersionInfo';
import RelatedDropdown from 'pages/Dataset/components/RelatedDatasets/RelatedDropdown';

import { buildDropdownData } from './dropdownData';

type Props = {
  url_path: string;
  id: string;
};

const RelatedDatasets = ({ url_path, id }: Props) => {
  const { system_model } = useVersionInfo();
  const isShowingV4 = useIsShowingV4();

  const { data: relatedData, isLoading } = useRelatedDatasets(isShowingV4, id);

  const dropdownData = buildDropdownData(relatedData);
  const newDropdownData =
    system_model === 'undefined'
      ? dropdownData.filter(({ label }) => ['Version', 'System model', 'Geography', 'Activity name'].includes(label))
      : dropdownData;
  return (
    <AppCard>
      <Heading as="h4" size="md">
        Browse Related Datasets
      </Heading>
      <Grid
        gap={2}
        mt={{ xs: '1rem', sm: 0 }}
        templateColumns={{ lg: system_model !== 'undefined' ? '1fr 2fr 4fr 1fr 2fr' : '1fr 2fr 4fr 1fr' }}
      >
        {newDropdownData.map(({ label, options, gridProps, tooltip, linkText, linkHref, useCustomDropdown }) => (
          <GridItem key={label} {...gridProps} display="flex" flexDirection="column">
            <Skeleton isLoaded={!isLoading} flex={1} display="flex" flexDirection="column">
              <RelatedDropdown
                options={options}
                label={label}
                url_path={url_path}
                tooltip={tooltip}
                linkText={linkText}
                linkHref={linkHref}
                useCustomDropdown={useCustomDropdown}
              />
            </Skeleton>
          </GridItem>
        ))}
      </Grid>
    </AppCard>
  );
};
export default RelatedDatasets;
